import { render } from "./ApplicationMark.vue?vue&type=template&id=55a0919a"
const script = {}
script.render = render

export default script